/** @format */

export const DEFAULT_TEST_ID = 'mini-product-card';
